import { getToken } from '@/scripts/token.js';
import constants from '@/constants';
import { axiosRequest, METHOD } from '@/api/default.js';

export async function getTagsAxios(isFeatured = false) {
    const token = await getToken();
    if (token === null) {
        throw 'Authorization token was not detected';
    }

    return {
        method: METHOD.GET,
        url: `${process.env.VUE_APP_BACKEND_URL}${constants.URL.TAG_GET}`,
        params: {
            featured: isFeatured,
        },
        headers: {
            Authorization: token,
            'Cache-Control': 'no-cache',
        },
    };
}

export async function getTags(isFeatured = false) {
    const response = await axiosRequest({
        url: constants.URL.TAG_GET,
        method: METHOD.GET,
        requestName: 'GET TAG',
        isLoader: false,
        params: {
            featured: isFeatured,
        },
    });

    return response == null ? [] : response;
}

export async function parseTags(assetTypeID, gameID) {
    const response = await axiosRequest({
        url: constants.URL.TAG_PARSE,
        method: METHOD.POST,
        requestName: 'PARSE TAGS',
        params: {
            asset_type_id: assetTypeID,
            game_id: gameID,
        },
    });

    return response == null ? false : true;
}

export async function createTag(data) {
    const response = await axiosRequest({
        url: constants.URL.TAG_CREATE,
        method: METHOD.POST,
        requestName: 'CREATE TAG',
        data: data,
    });

    return response;
}

export async function updateTag(data) {
    const response = await axiosRequest({
        url: constants.URL.TAG_UPDATE,
        method: METHOD.PATCH,
        requestName: 'UPDATE TAG',
        data: data,
    });

    return response == null ? false : true;
}

export async function deleteTag(id) {
    const response = await axiosRequest({
        url: constants.URL.TAG_DELETE,
        method: METHOD.DELETE,
        requestName: 'DELETE TAG',
        params: {
            tag_id: id,
        },
    });

    return response == null ? false : true;
}
